import { type ReactNode, useState } from "react";
import { Calendar } from "../calendar";
import { Dialog, DialogContent, DialogTrigger } from "../dialog";
import { useMediaQuery } from "../hooks/media-query";
import { Popover, PopoverContent, PopoverTrigger } from "../popover";

export const DatePicker = ({
  value,
  onChange,
  children,
  "data-cy": _dataCy,
}: {
  value: Date | undefined | null;
  onChange: (val: Date | undefined) => void;
  "data-cy"?: string;
  children?: ReactNode;
}) => {
  const isDesktop = useMediaQuery("lg");
  const [open, setOpen] = useState(false);

  const handleSelect = (val: Date | undefined) => {
    if (val != null) {
      onChange(val);
    }
    setOpen(false);
  };

  const calendarDataCy = `${_dataCy ?? "date-picker"}-calendar`;

  return isDesktop ? (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        asChild
        data-cy={_dataCy}
        onFocusCapture={(e) => {
          e.stopPropagation();
        }}
      >
        {children}
      </PopoverTrigger>
      <PopoverContent className="z-50 w-auto p-0" align="start">
        <Calendar
          data-cy={calendarDataCy}
          mode="single"
          captionLayout="dropdown"
          selected={value ?? undefined}
          onSelect={handleSelect}
          disabled={(date) =>
            date > new Date() || date < new Date("1900-01-01")
          }
        />
      </PopoverContent>
    </Popover>
  ) : (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild data-cy={_dataCy}>
        {children}
      </DialogTrigger>
      <DialogContent className="w-auto p-0!">
        <Calendar
          data-cy={calendarDataCy}
          mode="single"
          captionLayout="dropdown"
          selected={value ?? undefined}
          onSelect={handleSelect}
          disabled={(date) =>
            date > new Date() || date < new Date("1900-01-01")
          }
        />
      </DialogContent>
    </Dialog>
  );
};
